// extracted by mini-css-extract-plugin
export default {"presaleWrapper":"style_presaleWrapper__j+LIp"};